/**
 * Try to get markdown content from a provided uri.
 */
export async function fetchMarkdown(url: string): Promise<string> {
  try {
    const response = await fetch(url);
    const text = await response.text();

    if (!response.ok) {
      throw new Error(
        `Bad response: ${response.status} ${response.statusText}`
      );
    }

    return text;
  } catch (error) {
    throw new Error(`Failed to fetch/parse markdown from ${url}`, {
      cause: error
    });
  }
}
